



















import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
    InsHeader: () => import('@/components/business/header/InsHeader.vue'),
    PcHeader: () => import('@/components/business/header/layout/PcHeader.vue'),
    InsFooter: () => import('@/components/business/footer/InsFooter.vue'),
    InsSlideMenu: () => import('@/components/business/header/InsSlideMenu.vue'),
    InsSidebar: () => import('@/components/business/header/InsSidebar.vue'),
    InsMenuLayout: () => import('@/components/business/header/InsMenuLayout.vue')
  }
})
export default class layout extends Vue {
  timer: any = null;

  get isMobile () {
    return this.$store.state.isMobile;
  }

  // 活動狀態
  get activityStatus () {
    return this.$store.state.activityStatus;
  }

  created() {
    this.timer = setInterval(() => {
      this.$store.dispatch('checkActivityStatus');
    }, 1000); // 每分钟检查一次
  }

  @Watch('activityStatus')
  onChange(val) {
    if (!val) clearInterval(this.timer);
  }
}
